import React from "react";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { OutlinedInput, Select as SelectField } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/styles"
import { ArrowDropDown } from "@material-ui/icons"
import { useSelector } from "react-redux"
import config from "../../config"
import { useAutoCompleteStyles } from "../../utils"

function Select({ label, options, value, disabled, handleChange, ...rest }) {
  const { t } = useTranslation();
  const { theme: { colors, bgColors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = useAutoCompleteStyles(bgColors, colors)()

  return (
    <FormControl id="name-label" fullWidth variant="outlined" disabled={disabled} {...rest}>
      <InputLabel id="name-label" style={{color: colors.colorText}}>
        {label}
      </InputLabel>
      <SelectField
        labelId="name-label"
        id="name"
        fullWidth
        value={value}
        onChange={value => handleChange(value)}
        labelWidth={label.length * 11}
        input={
          <OutlinedInput
            label={label}
            classes={{ root: isContrast ? classes.outlinedRoot : '' }}
          />
        }
        IconComponent={(props) => (
          <ArrowDropDown {...props} style={{ color: colors.colorText }} />
        )}
        style={{ backgroundColor: bgColors.bgPrimary200, color: colors.colorText }}
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: bgColors.bgPrimary200,
              color: colors.colorText,
              borderRadius: '10px',
            },
          },
        }}
      >
        {options.map((o) => (
          <MenuItem key={o.id} value={o.id}>
            {label === t('category_type') ? t(o.name) : (o.name)}
          </MenuItem>
        ))}
      </SelectField>
    </FormControl>
  )
}

export default Select;
